import { defaultNamespace, fallbackLanguage, languages, preloadNamespaces } from './constants';

export function getOptions(lng = fallbackLanguage, ns = preloadNamespaces) {
  return {
    supportedLngs: languages,
    fallbackLng: fallbackLanguage,
    lng,
    fallbackNS: defaultNamespace,
    defaultNS: defaultNamespace,
    ns,
  };
}
